var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status.length > 0)?_c('b-badge',{attrs:{"pill":"","variant":_vm.status[0].variant}},[_c('span',{domProps:{"textContent":_vm._s(_vm.status.length)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }